import { Typography, Box } from "@mui/material";
import React, { useEffect, useState } from "react";
import RadioButton from "../../../common/RadioButton";
import { LinkButton, SecondaryButton } from "../../../common/Buttons";
import {
  getHealthcareProxy,
  getHealthcareQuestionByCategory,
  postHealthcareProxy,
} from "../../../services/documentServices";
import { QuestionByCategoryType } from "../../../constants/constants";
import { toast } from "react-hot-toast";
import { getUserIdFromLocalStorage } from "../../../utils/Utilities";
import { useTranslation } from "react-i18next";
import { Circles } from "react-loader-spinner";
const AssetsManagement = ({ next, setButtonDisabled }) => {
  const { t } = useTranslation();
  let uID = getUserIdFromLocalStorage();
  const [assetManagementListState, setAssetManagementListState] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [data, setData] = useState([]);
  async function fetchData() {
    setIsLoading(true);
    try {
      const result = await getHealthcareProxy(uID);
      if (result?.success && result?.payLoad) {
        setData(result.payLoad);
      }
    } catch (e) {
      console.log(e);
    } finally {
      setIsLoading(false);
    }
  }

  async function fetchAssetManagement() {
    setButtonDisabled(true);
    const result = await getHealthcareQuestionByCategory(
      QuestionByCategoryType.ASSET_MANAGEMENT,
      uID
    );
    if (result?.success) {
      setAssetManagementListState(
        {
          title: result?.payLoad[0],

          data: result?.payLoad[0]?.questions?.map((item) => ({
            id: item.questionId,
            yes: item?.healthProxyAnswer?.answer
              ? item?.healthProxyAnswer?.answer === "yes"
                ? true
                : false
              : null,
            ...item,
            ...item.healthProxyAnswer,

          }))
        }
      );
    }
    setButtonDisabled(false);
  }

  useEffect(() => {
    fetchData();
    fetchAssetManagement();
  }, []);
  const setYes = (e, type) => {
    const updateList = {
      ...assetManagementListState,
      data: assetManagementListState?.data?.map((ele) => {
        return ele.id == e.id ? type === 'q-9' ? { ...ele, yes: true, answer: e.data } : { ...ele, yes: true } : ele;
      })
    };
    setAssetManagementListState(updateList);
  };
  const setNo = (e) => {
    const updateList = {
      ...assetManagementListState,
      data: assetManagementListState?.data?.map((ele) => {
        return ele.id == e.id ? { ...ele, yes: false } : ele;
      })
    };
    setAssetManagementListState(updateList);
  };

  const setAllTrue = (currentObj) => currentObj.yes == true;

  const handleSubmit = async () => {
    setButtonDisabled(true);
    console.log('heloo', ...assetManagementListState?.data?.map((item, index) => ({
      ...item,
      answer: item.sortingId !== 9 ? item.yes ? "yes" : item.yes == null ? null : "no" : item.answer
    })))
    const payload = {
      ...data,
      healthProxyAnswers: [
        ...data.healthProxyAnswers,
        ...assetManagementListState?.data?.map((item, index) => ({
          ...item,
          answer: item.sortingId !== 9 ? item.yes ? "yes" : item.yes == null ? null : "no" : item.answer
        })),
      ],
      checkListTab3: assetManagementListState?.data.every(setAllTrue) ? 2 : 1,
    };
    const result = await postHealthcareProxy(payload, uID);
    if (result?.success) {
      // toast.success(
      //   t(
      //     result?.message
      //       .toLowerCase()
      //       .replaceAll(" ", "-")
      //       .replaceAll("/", "-")
      //       .replaceAll(",", "")
      //       .replaceAll("'", "")
      //   )
      // );
      next();
    }
    setButtonDisabled(false);
  };
  const [notes, setNotes] = useState({
    note: "",
  });
  return (
    <form
      id="form_submit"
      onSubmit={(e) => {
        e.preventDefault();
        handleSubmit();
      }}
      style={{
        width: "100%",
        display: "flex",
        justifyContent: "center",
      }}
      className="summary-table documents-card-height"
    >
      {isLoading ? (
        <Box component="div" className="loader-container">
          <Circles color="#dfc8db" height={80} width={80} />
        </Box>
      ) : (
        <Box component="div" width="60%" className="medical-care-container">
          <Typography variant="p" fontWeight="bold">
            {t(assetManagementListState?.title?.translationKey)}
          </Typography>
          <Box padding="0 2rem" component="div" className="section-1">
            <Box component="div" className="sub-section-1">
              <Typography variant="p" marginRight="1rem">
                {t("YES")}
              </Typography>
              <Typography variant="p">{t("NO")}</Typography>
            </Box>
            <ol>
              {assetManagementListState?.data?.length > 0 && assetManagementListState?.data?.map((elem, index) => {
                return (
                  <li>
                    <Box component="div" key={index} className="sub-section-2">
                      <Typography variant="p" margin="0 0.5rem" width="80%">
                        {elem?.translationKey ? t(elem.translationKey) : ""}
                      </Typography>
                      {elem?.questionType === 2 &&
                        <>

                          <Box
                            padding="0 2rem"
                            component="div"
                            className="representation-in-court-textarea"
                          >
                            <Typography
                              sx={{
                                mt: 2,
                                display: "flex",
                              }}
                            >
                              {" "}

                              <textarea
                                id="w3review"
                                name="w3review"
                                rows="4"
                                cols="20"
                                placeholder={t("please-add-note-here")}
                                defaultValue={elem.answer}
                                onChange={(e) => {
                                  setYes({ ...elem, data: e.target.value }, "q-9");

                                }}
                              />
                            </Typography>{" "}
                          </Box>{" "}
                        </>}
                      {elem?.questionType === 1 && <>
                        <RadioButton
                          value="0"
                          theme="box"
                          paddingLeft="1rem"
                          checked={elem.yes}
                          onChange={() => {
                            setYes(elem);
                          }}
                        />
                        <RadioButton
                          value="1"
                          theme="box"
                          checked={!elem.yes && elem.yes != null}
                          onChange={() => {
                            setNo(elem);
                          }}
                        />
                      </>}
                    </Box>
                  </li>
                );
              })}
            </ol>
          </Box>
        </Box>
      )}
    </form>
  );
};

export default AssetsManagement;
